<template>
  <el-table
    border
    highlight-current-row
    tooltip-effect="dark"
    :data="data"
    :max-height="height"
  >
    <el-table-column header-align="center" label="时间" prop="date" width="160">
    </el-table-column>

    <el-table-column header-align="center" label="类别">
      <el-table-column
        show-overflow-tooltip
        align="center"
        min-width="30"
        v-for="col in cols"
        :key="col.id"
        :label="col.name"
      >
        <template slot-scope="prop">
          {{ `${formatNum(prop.row, col.key)}${col.unit || ''}` }}
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import { export_table_to_excel as exceljs } from '@/utlis/exportExcel'

export default {
  props: {
    cols: Array,
    data: Array,
    height: Number
  },
  data() {
    return {
      toFixed: true
    }
  },
  methods: {
    formatNum(row, key) {
      let num = row[key]
      if (!+num) return num

      if (key === 'lon' || key === 'lat') {
        return Number(num)
      }

      const sp = num.toString().split('.')
      if (this.toFixed && sp[1] && sp[1].length > 1) {
        return Number(num).toFixed(2)
      } else {
        return Number(num)
      }
    },
    exportExcel(title) {
      exceljs(this.$el, title)
    }
  }
}
</script>

<style lang="css" scoped></style>
